import { Pipe, PipeTransform } from '@angular/core';

import { ImageQueryService } from './image-query.service';

@Pipe({
	name: 'imageQuery',
	pure: true,
	standalone: false,
})
export class ImageQueryPipe implements PipeTransform {
	constructor(private readonly queryService: ImageQueryService) {}

	transform(image: string, size: { width: number; height: number }): string {
		return this.queryService.transform(image, size);
	}
}
